import type { ListingTemplateProduct } from "./listing-templates";
import {
  exampleProduct,
  simpleProduct,
  technicalProduct,
} from "@/mocks/listing-template-product";

/**
 * Preview content profiles.
 *
 * Three realistic product datasets used to review every listing template so a
 * single "perfect" product is not the only thing under evaluation. Each profile
 * deliberately exercises different content shapes (rich, sparse, technical).
 */

export type PreviewDatasetId = "rich" | "simple" | "technical";

export interface PreviewDataset {
  id: PreviewDatasetId;
  name: string;
  description: string;
  product: ListingTemplateProduct;
}

export const previewDatasets: PreviewDataset[] = [
  {
    id: "rich",
    name: "Rich product",
    description:
      "Many images, long description, variants, full specifications, shipping and returns.",
    product: exampleProduct as ListingTemplateProduct,
  },
  {
    id: "simple",
    name: "Simple product",
    description:
      "One image, short copy, few specs, no variants, no brand, no warranty and no returns copy.",
    product: simpleProduct as ListingTemplateProduct,
  },
  {
    id: "technical",
    name: "Technical product",
    description:
      "Dense specifications, dimensions, material, compatibility and multiple variants.",
    product: technicalProduct as ListingTemplateProduct,
  },
];

export function datasetById(id: string | null | undefined): PreviewDataset {
  return previewDatasets.find((d) => d.id === id) ?? previewDatasets[0];
}